<template>
  <button class="appButton btn" :class="type" @click="onClick">
    <slot></slot>

    <app-icon v-if="icon" :width="iconStyle.width" :height="iconStyle.height">
      <icon-arrow-right></icon-arrow-right>
    </app-icon>
  </button>
</template>

<script>
import { fixUrl } from '@/utils/helpers'
export default {
  props: {
    type: {
      type: String,
      default: 'outline'
    },
    icon: {
      type: [String, Boolean],
      default: false
    },
    link: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconStyle () {
      if (this.$store.getters.isPC) {
        return {
          width: 18,
          height: 15
        }
      } else {
        return {
          width: 14,
          height: 10
        }
      }
    }
  },
  methods: {
    onClick () {
      if (this.link) {
        window.open(fixUrl(this.link))
      } else {
        this.$emit('click')
      }
    }
  }
}
</script>

<style lang="scss">
.appButton {
  padding: 8px 20px;
  border-radius: 100px;
  outline: none;
  &.outline {
    color: #fff;
    border: 1px solid #fff;
    background: transparent;
    &:hover {
      color: #000;
      background: #fff;
    }
  }
}
@include isMobile {
  .appButton {
    padding: rem(8) rem(20);
    border-radius: rem(100);
    font-size: rem(14);
    &.outline {
      color: #fff;
      background: transparent;
      &:hover {
        color: #fff;
        background: transparent;
      }
    }
    &:focus {
      box-shadow: 0 0 0 0
    }
  }
}
</style>
